import React, { useState, useEffect } from 'react';
import { Select, MenuItem, TextField, SelectChangeEvent } from '@mui/material';
import { GridRenderEditCellParams } from '@mui/x-data-grid';

const ChartOfAccountsCell = (params: GridRenderEditCellParams) => {
  const [isCustom, setIsCustom] = useState(false);
  const [customValue, setCustomValue] = useState('');

  const predefinedOptions = ['Purchase', 'Sales', 'Abnormal'];

  useEffect(() => {
    if (!predefinedOptions.includes(params.value as string)) {
      setCustomValue(params.value as string);
      setIsCustom(true);
    } else {
      setIsCustom(false);
    }
  }, [params.value]);

  const handleChange = (event: SelectChangeEvent<string>) => {
    const value = event.target.value;
    if (value === 'Custom') {
      setIsCustom(true);
      params.api.setEditCellValue({
        id: params.id,
        field: params.field,
        value: customValue,
      });
    } else {
      setIsCustom(false);
      params.api.setEditCellValue({
        id: params.id,
        field: params.field,
        value,
      });
    }
  };

  const handleCustomInputChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    setCustomValue(value);
    if (value.trim() !== '') {
      params.api.setEditCellValue({
        id: params.id,
        field: params.field,
        value,
      });
    }
  };

  return (
    <>
      <Select
        value={
          predefinedOptions.includes(params.value as string)
            ? (params.value as string)
            : 'Custom'
        }
        onChange={handleChange}
        fullWidth>
        {predefinedOptions.map(option => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
        <MenuItem value="Custom">Custom</MenuItem>
      </Select>
      {isCustom && (
        <TextField
          value={customValue}
          onChange={handleCustomInputChange}
          fullWidth
          variant="outlined"
          size="small"
          style={{ marginTop: '8px' }}
        />
      )}
    </>
  );
};

export default ChartOfAccountsCell;
